
import Vue, { PropType } from 'vue'
import { IGCB2Connector, ManualCommunication, SidebarItem, WhatsappLinkSettings } from '@/types/GCB2'
import YClientsLink from '@/components/iconLinks/YClientsLink.vue'
import DikidiLink from '@/components/iconLinks/DikidiLink.vue'
import ProfSalonLink from '@/components/iconLinks/ProfSalonLink.vue'
import PhoneLink from '@/components/iconLinks/PhoneLink.vue'
import SonlineLink from '@/components/iconLinks/SonlineLink.vue'
import AltegioLink from '@/components/iconLinks/AltegioLink.vue'
import { Connector, Project } from '../../../../types/main'
import { useGcb2Store } from '@root/src/store/stores/gcb2/gcb2'
import { mapStores } from 'pinia'
import { CONNECTOR_TYPES } from '../../../../vars/general'
import messageVarsService from '../../../../helpers/gcb2/messageVars'
import AmoCrmLink from '../../../iconLinks/AmoCrmLink.vue'
import { checkRole } from '../../../../helpers/roles'
import ChatLink from '@root/src/components/iconLinks/ChatLink.vue'
import { TASKLIST_ACTION_TYPES } from '@root/src/vars/GCB2'
export default Vue.extend({
    components: {
        YClientsLink,
        DikidiLink,
        SonlineLink,
        ProfSalonLink,
        PhoneLink,
        AltegioLink,
        AmoCrmLink,
        ChatLink
    },
    props: { activeSidebarItem: { type: Object as PropType<SidebarItem> }, manualCommunication: { type: Object as PropType<ManualCommunication> } , },
    data: () => ({
        TASKLIST_ACTION_TYPES,
    }),
    computed: {
        ...mapStores(useGcb2Store),
        projectId(): string {
            return this.$router.currentRoute.params.id
        },
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        chatLinkSettings(): WhatsappLinkSettings {
            const gcb2Connector = this.project.connectors.find(
                el => el.connectorType === CONNECTOR_TYPES.GCB2
            )
            return gcb2Connector?.whatsappLinkSettings
        },
        loadingActionsCommunicationIds(): string[] {
            return this.$store.state.GCB2.taskList.loadingActionsCommunicationIds
        },
        editDisabled(): boolean {
            if (this.manualCommunication && !status) {
                return this.loadingActionsCommunicationIds.includes(this.manualCommunication.communicationId)
            } else {
                return false
            }
        },
    },

    methods: {
        checkRole,
        openActionModal(item: ManualCommunication, actionType: string) {
            this.gcb2Store.openActionModal({
                actionType,
                communicationId: item.communicationId,
                opened: true,
            })
        },
    },
    async created() {},
    mounted() {},
})
